import React from 'react'
import { Grid, TextField } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { Editor } from '@tinymce/tinymce-react'

const TextTabContent = ({ editorRef }) => {
  const methods = useFormContext()
  const { register, setValue, formState: { errors } } = methods
  const log = () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent())
    }
  }

  const bodyEditorChangeHandler = value => {
    setValue('body', value)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          label="Title"
          {...register('title', { required: { value: true, message: 'Invalid Title' } })}
          error={!!errors?.title}
          helperText={errors.title?.message}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <Editor textareaName="body"
          apiKey='z12laxyuih330arof60qaoyuk0paplg8btb7g2cr265apwyi'
          onEditorChange={bodyEditorChangeHandler}
          onInit={(_evt, editor) => {
            editorRef.current = editor
            return editorRef.current
          }}
          init={{
            height: 500,
            menubar: false,
            plugins: [
              'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
              'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
              'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
            ],
            toolbar: 'undo redo | blocks | ' +
              'bold italic forecolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
            skin: 'oxide-dark',
            content_css: 'dark',
            placeholder: 'Body'
          }}
        />
      </Grid>
      <Grid item xs={12}>
      </Grid>
    </Grid>
  )
}

export default TextTabContent
